// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3TrVp","cell":"ColumnAccessor_cell__1XmHI","firstCellAccent":"ColumnAccessor_firstCellAccent__2dCbm"};